module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/promos/promo-create/promo-create.component.scss
// module id = ./src/app/promos/promo-create/promo-create.component.scss
// module chunks = main